import api from './authService';

export const dashboardService = {
  getAnalytics: async () => {
    const response = await api.get('/dashboard/analytics');
    return response.data;
  },

  getProjectAnalytics: async (projectId) => {
    const response = await api.get(`/dashboard/projects/${projectId}/analytics`);
    return response.data;
  }
};
